import React from 'react';
import { Globe } from 'lucide-react';

const LanguageSwitcher = ({ currentLang, onLanguageChange }) => {
  return (
    <div className="language-switcher">
      <Globe className="globe-icon" size={18} />
      <button
        className={`lang-btn ${currentLang === 'pt' ? 'active' : ''}`}
        onClick={() => onLanguageChange('pt')}
      >
        PT
      </button>
      <span className="lang-divider">|</span>
      <button
        className={`lang-btn ${currentLang === 'en' ? 'active' : ''}`}
        onClick={() => onLanguageChange('en')}
      >
        EN
      </button>
    </div>
  );
};

export default LanguageSwitcher;